// import AddressState from '@/types/AddressState'
// import Bank from '@/types/Bank'
// import BookingStatus from '@/types/BookingStatus'
// import CarerApplicationStatus from '@/types/CarerApplicationStatus'
// import CarerAssessmentQuestion from '@/types/CarerAssessmentQuestion'
// import CarerDocumentType from '@/types/CarerDocumentType'
// import CarerOnboardingStatus from '@/types/CarerOnboardingStatus'
// import CarerType from '@/types/CarerType'
// import { CheckinData } from '@/types/CheckinData'
// import { CheckoutData } from '@/types/CheckoutData'
// import Country from '@/types/Country'
// import DependentType from '@/types/DependentType'
// import { SessionRateAmount } from '@/types/formData/SessionRateAmount'
// import Institution from '@/types/Institution'
// import InvoiceItemType from '@/types/InvoiceItemType'
// import JobStatus from '@/types/JobStatus'
// import KeyLabel from '@/types/KeyLabel'
// import Language from '@/types/Language'
// import MaritalStatus from '@/types/MaritalStatus'
// import Nationality from '@/types/Nationality'
// import Occupation from '@/types/Occupation'
// import PaymentMethod from '@/types/PaymentMethod'
// import PaymentProvider from '@/types/PaymentProvider'
// import Platform from '@/types/Platform'
// import PlatformContentMediaPreset from '@/types/PlatformContentMediaPreset'
// import Postcode from '@/types/Postcode'
// import Race from '@/types/Race'
// import RateChildren from '@/types/RateChildren'
// import RateExtra from '@/types/RateExtra'
// import RateHour from '@/types/RateHour'
// import Religion from '@/types/Religion'
// import ReviewQuestion from '@/types/ReviewQuestion'
// import SessionCancelReasonOption from '@/types/SessionCancelReasonOption'
// import SessionCarerApplicationStatus from '@/types/SessionCarerApplicationStatus'
// import SessionDependentRoutineType from '@/types/SessionDependentRoutineType'
// import SessionEventTimelineItem from '@/types/SessionEventTimelineItem'
// import SessionEventType from '@/types/SessionEventType'
// import SessionServiceType from '@/types/SessionServiceType'
// import SessionStatus from '@/types/SessionStatus'
// import SessionType from '@/types/SessionType'
// import UserGroup from '@/types/UserGroup'
import { defineStore } from "pinia";
import { ref } from "vue";
import CdnService from "@/services/CdnService";
import type { Copywriting } from "@/types/Metadata";

export const useResourcesStore = defineStore("resources", () => {
  const resourcesHash = ref("");
  const countries = ref();
  const payments = ref();
  const itemToBring = ref<Record<string,any>>({});
  const states = ref();
  const termConditions = ref<Record<string,any>>({});
  const landingPages = ref()
  const logo = ref()
  const whatsappLink = ref<Record<string,string>>({})
  const copywriting = ref<Copywriting>({})
  const maxChildAge = ref<Record<string,number>>()
  const minChildAge = ref<Record<string,number>>()
  const includeMealRates = ref<Record<string,number>>()
  const key = ref<String[]>([])

  const initResource = (resource:any) =>{

  countries.value = resource.countries
    payments.value = resource.payments
    itemToBring.value = resource.itemToBring
    states.value = resource.states
    termConditions.value = resource.termsCondition
    logo.value = resource.logo
    landingPages.value = resource.landingPages
    whatsappLink.value = resource.whatsappLink
    copywriting.value = resource.copywriting
    maxChildAge.value = resource.maxChildAge
    minChildAge.value = resource.minChildAge
    includeMealRates.value = resource.includeMealRates
    key.value = resource.key

  }


  const setupCdn = async (hash: string) => {
    //get the old resource if exists
    const localResourceHash = localStorage.getItem("resourcesHash");
    let resource

    if (localResourceHash !== hash || localResourceHash == null) {
      localStorage.removeItem("resourceHash");

      try {
        const response = await CdnService.getResources(hash);

        if (response.data) {

          // assign value to the storage 
          resource = response.data

          localStorage.setItem('resourceData', JSON.stringify(resource))
          localStorage.setItem('resourceHash', hash);


        }
      } catch (error) {
        console.error(error);
      }


    }else{
        //unpack the local resource 
        const resourceString = localStorage.getItem('resourceData')
        if(resourceString){
            resource = JSON.parse(resourceString)
        }


    }


    //load inside the store
    initResource(resource)

    console.log('finish setup cdn', resource)

  };

  return {
    resourcesHash,
    countries,
    payments,
    itemToBring,
    states,
    termConditions,
    logo,
    landingPages,
    copywriting,
    maxChildAge,
    minChildAge,
    whatsappLink,
    includeMealRates,
    key,
    setupCdn,
  };
});
